import { render, staticRenderFns } from "./MovingPregnancy.vue?vue&type=template&id=7b195053&scoped=true&"
import script from "./MovingPregnancy.vue?vue&type=script&lang=js&"
export * from "./MovingPregnancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b195053",
  null
  
)

export default component.exports